// Used as a fallback for any countries defined in the ratingsboards that are not defined in the skugroups
export const ROW = 'row';

export const UNRATED = 'unrated';

export const REGION_COOKIES = {
  COUNTRY: 'country',
  READING_LANGUAGE: 'locale',
};

export const LANGUAGE_LABELS = {
  'en': 'English',
  'fr': 'Français',
  'de': 'Deutsch',
  'es': 'Español',
  'it': 'Italiano',
  'ru': 'Pусский',
  'pl': 'Polska',
  'tr': 'Türkiye',
  'cs': 'čeština',
  'ko': '대한민국',
  'pt': 'Brasil',
  'zh-CN': '简体中文', // simplified
  'zh-TW': '繁體中文', // traditional
};



// WEBPACK FOOTER //
// ./lib/rlink-regions/constants.js